const whitelistEvent = {
  listeners: [],
  
  subscribe(callback) {
    console.log('✅ Event subscribed');
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    };
  },
  
  emit() {
    console.log('🔥 Event emitted, listeners:', this.listeners.length);
    this.listeners.forEach(callback => callback());
  }
};

export default whitelistEvent;